<template>
    <div>
        <modal :show.sync="show_modal" :hide-footer="true">
            <div class="mb-4">
                <h2 class="mb-0">Reload Balance</h2>
            </div>
            <b-row style="min-width: 500px;">
                <div class="px-3 w-100">
                    <el-tabs type="border-card" @tab-click="tabChanged" v-model="activeTab">
												<el-tab-pane label="Points Reload" name="points">
                            <b-form class="w-100" @submit.prevent="reloadFintscoreReport">
																<b-col cols="12">
                                    <b-form-group label="Points Amount (Points)" class="mb-4">
                                        <b-form-input
                                        v-model="points_no"
                                        type="number"
                                        size="md"
																				required
                                        ></b-form-input>
																				<small>Price : 1 Points = RM {{ topup_points_price }}</small>
                                    </b-form-group>
                                    <b-form-group label="Total Amount (RM)" class="mb-1">
                                        <b-form-input
                                        v-model="points_amount"
                                        type="number"
                                        size="md"
                                        disabled
                                        ></b-form-input>
                                    </b-form-group>
																		<small class="text-green" v-if="discount > 0">
																			{{ discount }}% discount applied!</small>
                                    <div class="text-center mt-4">
                                        <el-button native-type="submit" class="bg-primary text-white" :loading="is_loading_reload">Purchase</el-button>
                                    </div>
                                </b-col>
                            </b-form>
                        </el-tab-pane>
                        <el-tab-pane label="Normal Reload" name="normal" disabled>
														<b-form class="w-100" @submit.prevent="reloadFintscoreReport">
                                <b-col cols="12">
                                    <b-form-group label="Quantity" class="mb-4">
                                        <b-form-input
                                        v-model="report_no"
                                        type="number"
                                        size="md"
                                        required
                                        ></b-form-input>
																				<small>Price per report: RM{{ discount_fintscore_price }}</small>
                                    </b-form-group>
                                    <b-form-group label="Total Amount (RM)" class="mb-1">
                                        <b-form-input
                                        v-model="report_amount"
                                        type="number"
                                        size="md"
                                        disabled
                                        ></b-form-input>
                                    </b-form-group>
                                    <small class="text-green" v-if="discount > 0">
                                        {{ discount }}% discount applied!</small>
                                    <div class="text-center mt-4">
                                        <el-button native-type="submit" class="bg-primary text-white" :loading="is_loading_reload">Purchase</el-button>
                                    </div>
                                </b-col>
                            </b-form>
                        </el-tab-pane>
                        <el-tab-pane label="Bulk Reload"  name="bulk" v-if="auth_user.account_info.is_bulk_puchase && bulk_purchases.length > 0" disabled>
														<b-form class="w-100" @submit.prevent="reloadFintscoreReport">
                                <b-col cols="12">
                                    <h5>Purchase reports at a lower price.</h5>
																		<small>Price per report: RM{{ discount_fintscore_price }}</small>
                                    <b-form-radio 
                                        name="bulk_id"
                                        v-model="report_bulk_id" 
                                        :value="bulk.bulk_id"
                                        v-for="(bulk, index) in bulk_purchases" 
                                        :key="index"
                                        :required="true"
                                    >{{ bulk.bulk_qty_report }} reports - RM{{ bulk.bulk_amount | moneyFormatter }}</b-form-radio>
                                    <div class="text-center mt-4">
                                        <el-button native-type="submit" class="bg-primary text-white" :loading="is_loading_reload">Purchase</el-button>
                                    </div>
                                </b-col>
                            </b-form>
                        </el-tab-pane>
                    </el-tabs>
                </div>
            </b-row>
        </modal>  
    </div>
</template>
<script>
    import { Button,  Tabs, TabPane } from 'element-ui'
    import { useAuthStore } from '@/stores/authStore'
    import { useFintscoreStore } from '@/stores/fintscoreStore'
    import { mapState } from 'pinia'
    import {
    notifyFunctionMixin,
    helperFunctionMixin,
    axios,
    services,
    getHeader,
    debounce,
    swal
} from '@/assets/js/httpImports.js'


    export default {
        mixins: [notifyFunctionMixin,helperFunctionMixin],
        components: {
            [Tabs.name]: Tabs,
            [TabPane.name]: TabPane,
            [Button.name]: Button,
        },
        data() {
            return {
                report_no: 1,
                points_no: 10,
                show_modal: false,
                is_loading_reload: false,
                bulk_purchases: [],
                report_bulk_id: null,
                activeTab: 'points'
            }
        },
        created(){
            if(this.auth_user.account_info.is_bulk_puchase && (this.auth_user.subscription.scrb_is_my_own || this.checkRoleType(['admin']))){
                this.getBulkPurchaseList()
            }
        },
        methods: {
            tabChanged(tab){
                if(tab.name === 'bulk'){
                    this.report_bulk_id = null
                }
            },
            toggleModal() {
                this.show_modal = !this.show_modal;
            },
            getBulkPurchaseList(){
                axios.get(services.billing + 'bulk-packages', {headers:getHeader()})
                    .then(res => {
                        this.bulk_purchases = res.data.content
                    })
                    .catch(e => {
                        // this.errorFunction(e)
                    })   
            },
            reloadFintscoreReport(){
                if(this.report_no <= 0){
                    this.errorFunction('Minimum purchase of report: 1')
                    return
                }
                this.is_loading_reload = true
                let data = null
                if(this.activeTab === 'points'){
                    data = {
                        "cre_scrb_id": this.auth_user.subscription.scrb_id, //CURRENT ACTIVE SUBSCRIPTION ID
                        "cre_type":"POINTS", // REPORT, POINTS
                        "cre_qty": this.points_no, 
                        "cre_amount":this.topup_points_price, 
                        "cre_is_send_invoice":0, //1=true,0=false
                        "cre_callback":null,
                        "cre_redirect": window.location.href
                    }
                }else if(this.activeTab === 'normal'){
                    data = {
                        "cre_scrb_id": this.auth_user.subscription.scrb_id, //CURRENT ACTIVE SUBSCRIPTION ID
                        "cre_type":"REPORT", // REPORT, POINTS
                        "cre_qty": this.report_no, // REQUIRED IF cre_type == REPORTS , value Qty Report
                        "cre_amount":null, // REQUIRED IF cre_type == POINTS , value amount in RM 
                        "cre_is_send_invoice":0, //1=true,0=false
                        "cre_callback":null,
                        "cre_redirect": window.location.href
                    }
                }else{
                    data = {
                        "cre_scrb_id": this.auth_user.subscription.scrb_id, 
                        "cre_bulk_id": this.report_bulk_id,
                        "cre_type":"REPORT", 
                        "cre_qty": null, 
                        "cre_amount":null, 
                        "cre_is_send_invoice":0, 
                        "cre_callback":null,
                        "cre_redirect": window.location.href
                    } 
                }
                axios.post(services.billing + 'credit-reload', data, {headers:getHeader()})
                    .then(res => {
                        this.is_loading_reload = false
                        const billplz_url = res.data.payment.pay_url
				        window.location.href = billplz_url
                    })
                    .catch(e => {
                        this.is_loading_reload = false
                        this.errorFunction(e)
                    })
            }
        },
        computed:{
            ...mapState(useAuthStore, ['auth_user']),
            ...mapState(useFintscoreStore, ['discount_fintscore_price', 'discount', 'topup_points_price']),
            report_amount(){
                let total = this.discount_fintscore_price * this.report_no
                return total.toFixed(2)
            },
            points_amount(){
                let total = (this.points_no * this.topup_points_price);
                if(this.discount > 0){
									total = total * ((100 - this.discount)/100)
								}
                return total.toFixed(2)
            },
        },
    }
</script>